module.exports = __webpack_public_path__ + "img/holograms.fbbb7996.webp";